<template>
  <div class="index-page-issue" v-show="hasRequest">
    <early-account-suggest v-if="isIndex && isEarlyAccount" :ad-issue-map="adIssueMap" :suggest-overview="suggestOverview"></early-account-suggest>
    <issue-dashboard v-if="!isEarlyAccount" :key="conKey" :is-index="isIndex" :ad-issue-map="adIssueMap" :suggest-overview="suggestOverview"></issue-dashboard>
  </div>
</template>
<script>
  import {getHomepageIssues} from '../utils/api.js';
  import EarlyAccountSuggest from './EarlyAccountSuggest.vue';
  import IssueDashboard from './IssueDashboard.vue';
  export default {
    name: 'index-page-issue',
    props: {
      isIndex: Boolean
    },
    data() {
      return {
        hasRequest: false,
        isEarlyAccount: false,
        adIssueMap: {},
        suggestOverview: '',
        conKey: Date.now()
      }
    },
    computed: {
      issuePriority () {
        return this.adIssueMap.P0 && this.adIssueMap.P0.length > 0 ? 1 : (
          this.adIssueMap.P1 && this.adIssueMap.P1.length > 0 ? 2 : (
            this.adIssueMap.P2 && this.adIssueMap.P2.length > 0 ? 3 : 0
          )
        )
      },
      priorityText() {
        const priorityLabel = {
          1: '高',
          2: '中',
          3: '低'
        }[this.issuePriority];
        return this.issuePriority == 0 ? '账户内未检测到待优化内容，非常优秀，请继续保持！' : `当前账户中存在需要${priorityLabel}优解决的问题，请及时处理`;
      },
      isShowP0() {
        return this.adIssueMap.P0 && this.adIssueMap.P0.length > 0;
      },
      isShowP1() {
        return this.adIssueMap.P1 && this.adIssueMap.P1.length > 0;
      },
      isShowP2() {
        return this.adIssueMap.P2 && this.adIssueMap.P2.length > 0 && (this.isIndex && !this.isShowP0 || !this.insIndex);
      }
    },
    components: {
      EarlyAccountSuggest,
      IssueDashboard
    },
    created() {
      this.getIssueList();
    },
    methods: {
      async getIssueList(forceRefresh) {
        const loading = forceRefresh ? this.$loading({
          lock: true,
          text: '刷新中...',
          spinner: 'suggest-loading-icon',
          background: 'rgba(0, 0, 0, 0.3)',
          customClass: 'suggest-loading'
        }) : null;
        const result = await getHomepageIssues({forceRefresh, earlyAccountDiff: this.isIndex});
        loading && loading.close();
        this.hasRequest = true;
        if (result) {
          this.conKey = Date.now();
          this.isEarlyAccount = result.isEarlyAccount;
          this.adIssueMap = result.adIssueMap || {};
          this.suggestOverview = result.suggestOverview;
          this.$emit('change-suggest', result.suggestOverview, Object.keys(result.adIssueMap).length == 0, result.isEarlyAccount);
        }
      }
    }
  }
</script>